const ALL_TROOP_ATTACK_UP_EFFECT_ID = 50397254;
const ALL_TROOP_HP_UP_EFFECT_ID = 50397255;
const ALL_TROOP_DEFENSE_UP_EFFECT_ID = 50397279;
const FLEET_SIZE_UP_EFFECT_ID = 50397286;
const GOVERNOR_RECRUITMENT_SPEED_UP_EFFECT_ID = 50397302;

// Ported from storePackCatalog.generated.json; percent values use the game's internal /10 scale.
const allTroopEffects = (entries = []) => entries.map(([effectId, value]) => ({ effectId, value }));

const createDesignationBuff = ({
  itemGid,
  name,
  durationSeconds,
  durationLabel,
  description,
  quality,
  effects,
}) => ({
  itemGid,
  name,
  category: "designation",
  categoryLabel: "Designations",
  description,
  durationOptions: [{
    level: 0,
    durationSeconds,
    durationLabel,
    quality,
    effects,
  }],
  effects,
});

export const DESIGNATION_BUFF_CATALOG = [
  createDesignationBuff({
    itemGid: 67960834,
    name: "President",
    durationSeconds: 0,
    durationLabel: "While held",
    description: "Capital War designation: Attack, Defense, and Fleet Size of all Troops +12%.",
    quality: 4,
    effects: allTroopEffects([
      [ALL_TROOP_ATTACK_UP_EFFECT_ID, 120],
      [ALL_TROOP_DEFENSE_UP_EFFECT_ID, 120],
      [FLEET_SIZE_UP_EFFECT_ID, 120],
    ]),
  }),
  createDesignationBuff({
    itemGid: 67960835,
    name: "Governor",
    durationSeconds: 0,
    durationLabel: "While held",
    description: "City War designation: Attack and HP of all Troops +6%, plus Recruitment Speed +6%.",
    quality: 3,
    effects: allTroopEffects([
      [ALL_TROOP_ATTACK_UP_EFFECT_ID, 60],
      [ALL_TROOP_HP_UP_EFFECT_ID, 60],
      [GOVERNOR_RECRUITMENT_SPEED_UP_EFFECT_ID, 60],
    ]),
  }),
  createDesignationBuff({
    itemGid: 67960838,
    name: "Warlord",
    durationSeconds: 2592000,
    durationLabel: "30 days",
    description: "Designation reward: Attack of all Troops +10%.",
    quality: 4,
    effects: allTroopEffects([
      [ALL_TROOP_ATTACK_UP_EFFECT_ID, 100],
    ]),
  }),
  createDesignationBuff({
    itemGid: 67960839,
    name: "Star Tyrant",
    durationSeconds: 2592000,
    durationLabel: "30 days",
    description: "Designation reward: Attack of all Troops +10%.",
    quality: 4,
    effects: allTroopEffects([
      [ALL_TROOP_ATTACK_UP_EFFECT_ID, 100],
    ]),
  }),
  createDesignationBuff({
    itemGid: 67960841,
    name: "Void Tyrant",
    durationSeconds: 864000,
    durationLabel: "10 days",
    description: "Designation reward: Attack of all Troops +8%.",
    quality: 4,
    effects: allTroopEffects([
      [ALL_TROOP_ATTACK_UP_EFFECT_ID, 80],
    ]),
  }),
  createDesignationBuff({
    itemGid: 67960842,
    name: "Frenzy Master",
    durationSeconds: 864000,
    durationLabel: "10 days",
    description: "Designation reward: Attack of all Troops +8%.",
    quality: 4,
    effects: allTroopEffects([
      [ALL_TROOP_ATTACK_UP_EFFECT_ID, 80],
    ]),
  }),
  createDesignationBuff({
    itemGid: 67960850,
    name: "Head of State",
    durationSeconds: 864000,
    durationLabel: "10 days",
    description: "Designation reward: Attack of all Troops +12%.",
    quality: 4,
    effects: allTroopEffects([
      [ALL_TROOP_ATTACK_UP_EFFECT_ID, 120],
    ]),
  }),
  createDesignationBuff({
    itemGid: 67960851,
    name: "God of Killing",
    durationSeconds: 864000,
    durationLabel: "10 days",
    description: "Designation reward: Attack of all Troops +12%.",
    quality: 4,
    effects: allTroopEffects([
      [ALL_TROOP_ATTACK_UP_EFFECT_ID, 120],
    ]),
  }),
];

export default DESIGNATION_BUFF_CATALOG;
